// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

import {
  InvitedOnboardingStep,
  UpdateInvitedOnboardingStepResult,
} from "./types";

export const params = {
  get invitedStep() {
    return InvitedOnboardingStep;
  },
};
export const returnType = UpdateInvitedOnboardingStepResult